import type { ReactNode } from "react";

type HoverTextPlacement = "top-left" | "top-center" | "bottom-center";

type HoverTextProps = {
  children: ReactNode;
  message: string;
  isEnabled?: boolean;
  placement?: HoverTextPlacement;
  className?: string;
};

const placementClassName: Record<HoverTextPlacement, string> = {
  "top-left": "bottom-full left-0 mb-2",
  "top-center": "bottom-full left-1/2 mb-2 -translate-x-1/2",
  "bottom-center": "top-full left-1/2 mt-2 -translate-x-1/2",
};

const HoverText = ({
  children,
  message,
  isEnabled = true,
  placement = "top-center",
  className = "",
}: HoverTextProps) => {
  if (!isEnabled || !message.trim()) {
    return <>{children}</>;
  }

  return (
    <div className={`group relative ${className}`}>
      {children}
      <div
        className={`pointer-events-none absolute z-20 hidden w-64 rounded-2xl border border-myteengig-border bg-myteengig-background px-3 py-2 text-left text-xs font-medium text-myteengig-text-primary shadow-lg group-hover:block ${placementClassName[placement]}`}
        role="tooltip"
      >
        {message}
      </div>
    </div>
  );
};

export default HoverText;
